import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import MarqueeBanner from './components/MarqueeBanner';
import StatsSection from './components/StatsSection';
import FounderSection from './components/FounderSection';
import EngagementsSection from './components/EngagementsSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import GallerySection from './components/GallerySection';
import CtaBanner from './components/CtaBanner';

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <MarqueeBanner />
      <StatsSection />
      <FounderSection />
      <EngagementsSection />
      <ServicesSection />
      <TestimonialsSection />
      <GallerySection />
      <CtaBanner />
    </Layout>
  );
}